import React, {useState} from 'react'
import './Sidebar.css'
import { Link } from 'react-router-dom'; // <-- Keep this import for the Dashboard Link
import {House, Layers, ChartNoAxesCombined, Receipt, MapPin, MessagesSquare, Sparkles,  HandHelping, Settings} from 'lucide-react'

//Sidebar compoents holding main nav for web
export default function Sidebar({ isOpen, onBlueprintsClick }) {
    const [activeLink, setactiveLink] = useState('Home');

    const handleClick = (linkName) => {
        setactiveLink(linkName);
    }

    return (
        <div className={`sidebar ${isOpen ? '' : 'closed'}`}>
            < div className = "sidebar-content">
                <div className = "sidebar-logo">
                    <div>  
                        <img
                        src="/ProjexSiteWebLogo.png" // or use import if you're using a module path
                        alt="Projex Site Logo"
                        />
                        </div>
                </div>
                {/* Nav links */}
                < nav className ="sidebar-nav">
                    <ul>
                        <li>
                           <Link
                                to = "/dashboard"
                                className = { activeLink === 'Home' ? 'active' : ''}
                                onClick = {() => handleClick('Home')}
                            >                    
                            Home
                            <House className = "sidebar-icon"/>
                            </Link>
                        </li>
                        <li> 
                            <a
                                href = "#" 
                                className = { activeLink === 'Blueprints' ? 'active' : '' }
                                onClick = {(e) => {
                                    e.preventDefault();
                                    handleClick('Blueprints');
                                    onBlueprintsClick();
                                }}
                            > 
                                Blueprints
                                <Layers className = "sidebar-icon"/>

                            </a>
                        </li>
                        <li>
                            <a
                             href = "#"
                             className = { activeLink === 'Analytics' ? 'active' : ''}
                             onClick = {() => handleClick('Analytics')}
                             > 
                             Analytics
                            <ChartNoAxesCombined className = "sidebar-icon"/>

                             </a>
                        </li>
                         <li>
                            <Link
                            to = "/financials"
                                 className = { activeLink === 'Financials' ? 'active' : ''}
                                 onClick = {() => handleClick('Financials')}
                             > 
                             Financials
                             <Receipt className = "sidebar-icon"/>
                             </Link>
                        </li>

                        <li>
                            <a href = "#"
                               className = { activeLink === 'Map View' ? 'active' : ''}
                               onClick={() => handleClick('Map View')}
                            > 
                            Map View
                            <MapPin className = "sidebar-icon"/>

                            </a>
                        </li>
                        <li>
                            <a href = "#"
                               className = { activeLink === 'Messages' ? 'active' : ''}
                               onClick={() => handleClick('Messages')}
                            > 
                            Messages
                            <MessagesSquare className = "sidebar-icon"/>

                            </a>
                        </li>
                        <li>
                            <a href = "#"
                               className = { activeLink === 'AI Assistant' ? 'active' : ''}
                               onClick = {() => handleClick('AI Assistant')}
                            > 
                            AI Assistant
                            <Sparkles className = "sidebar-icon"/>
                            </a>
                        </li>
                        <li>
                            <Link
                                to="/pricing"
                                className = { activeLink === 'Pricing' ? 'active' : ''}
                                onClick = {() => handleClick('Pricing')}
                            >
                                Upgrade Plan
                                <HandHelping className = "sidebar-icon"/>
                            </Link>
                        </li>
                    </ul>
                </nav>
            </div>
            

            {/* Footer sec and logout*/}
            <div className = "sidebar-footer">
                <ul >
                    <li><a href = "#"
                            className = { activeLink === 'Help | Support' ? 'active' : ''}
                            onClick = {() => handleClick('Help | Support')}
                        >
                        Help | Support
                        </a>
                    </li>
                    <li><a href = "#"
                            className = { activeLink === 'Settings' ? 'active' : ''}
                            onClick = {() => handleClick('Settings')}
                        >
                        Settings
                        </a>
                    </li>
                    <li><a href = "#" className = "logout-link">Logout</a></li>
                </ul>
            </div>
        </div>
    );
}
